import { render, staticRenderFns } from "./leader-taskdeal.vue?vue&type=template&id=4acbd77f&scoped=true"
import script from "./leader-taskdeal.vue?vue&type=script&lang=js"
export * from "./leader-taskdeal.vue?vue&type=script&lang=js"
import style0 from "./leader-taskdeal.vue?vue&type=style&index=0&id=4acbd77f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acbd77f",
  null
  
)

export default component.exports